<template>
  <div class="free" v-bind:style= "{'background-image':'url(images/draw/bg/bg_yellow.jpg)' }">

    <div class="c-header">
      <div class="c-header__bg">
        <img src="images/draw/bg/bg_stone.png" alt="">
      </div>
      <div class="c-header__logo">
        <img src="images/draw/common/header_logo.png" alt="">
      </div>
    </div>

    <div class="free__text">
      <img src="images/draw/text/text_10.png" alt="">
    </div>

    <div class="free__input">
      <div class="free__canvas-wrap">
        <canvas width="500" height="500" ref="canvas" class="free__canvas"></canvas>
      </div>

      <div class="free__textfield">
        <textarea v-model="inputText" placeholder="" class="free__textarea u-pixel10" ref="textarea"></textarea>
      </div>

      <div class="free__btns">
        <button class="free__btn free__btn--0" v-on:click="setNum(0)">
          <img src="images/draw/btn/btn_0.png" alt="0">
        </button>
        <button class="free__btn free__btn--1" v-on:click="setNum(1)">
          <img src="images/draw/btn/btn_1.png" alt="1">
        </button>
        <button class="free__btn free__btn--clear" v-on:click="clear">
          <img src="images/draw/btn/btn_retry.png" alt="clear">
        </button>
      </div>
    </div>

    <button class="free__tw" v-on:click="shareTw">
      <img src="images/draw/btn/btn_twitter_free.png" alt="作ったプログラムを送る">
    </button >

    <transition name="fadein">
      <div class="free__hidden-comment" v-if="is16anime">
        <img src="images/draw/other/comic_16.png" alt="">
      </div>
    </transition>

    <div class="free__anime anime" v-if="isAnime">
      <div class="anime__inner">
        なにかしらの演出
      </div>
    </div>

    
    <div class="free__error error" v-if="isInputError" v-on:click="closeError">
      <div class="error__text">
        文字数がたりない
      </div>
    </div>

    <button v-on:click="toTop" class="c-btn--top">
      <img src="images/draw/btn/btn_return_top.png" alt="離脱してTOPに戻る">
    </button>

    <footer class="c-footer">
      <div class="c-footer__img">
        <img src="images/top/copyright.png" alt="©米スタジオ・Boichi／集英社">
      </div>
    </footer>
  </div>

</template>

<script>

import * as PIXI from 'pixi.js'
import { gsap } from 'gsap'
import { PixiPlugin } from 'gsap/PixiPlugin'

import {DrawCanvas} from '@/assets/js/DrawCanvas.js'

gsap.registerPlugin(PixiPlugin)
PixiPlugin.registerPIXI(PIXI)
gsap.defaults({ overwrite: 'auto' })

export default {
  components: {
  },
  data: function() {
    return {
      container: null,
      rectGraphics: [],
      inputText: "",
      digit: {x: 10, y: 10},
      rectSize: 50,
      palette: {
        "0": 0xFFFFFF,
        "1": 0x000000,
        "2": 0xff0000,
        "3": 0xff9900,
        "4": 0xffff00,
        "5": 0x66cc00,
        "6": 0x009900,
        "7": 0x006600,
        "8": 0x33ccff,
        "9": 0x0033cc,
        "A": 0x660099,
        "B": 0xff6699,
        "C": 0xffcc99,
        "D": 0x996633,
        "E": 0x993300,
        "F": 0x999999,
      },

      isAnime: false, // 演出
      isInputError: false, // 入力文字数エラー
      is16mode: false, // 16進数モード
      is16anime: false, // 16進数初回演出
      
      isDebug: true,
    }
  },
  created() {
    this.rectSize = 500 / this.digit.x
  },
  mounted() {

    const app = new PIXI.Application({
      width: 500, 
      height: 500, 
      view: this.$refs.canvas,
      backgroundColor: 0xFFFFFF, 
      resolution: window.devicePixelRatio || 1,
    });
    this.container = new PIXI.Container()
    app.stage.addChild(this.container);

    let dc = new DrawCanvas(this.digit, this.rectSize);

    // Rect
    for(let i = 0; i < this.digit.x * this.digit.y; i++) {
      let g = new PIXI.Graphics()
      let y = Math.floor(i / this.digit.y)
      g.beginFill(0xffffff)
      g.drawRect((i - y * this.digit.y) * this.rectSize, y * this.rectSize, this.rectSize, this.rectSize)
      g.alpha = 0
      g.tint = 0xFFFFFF
      g.endFill()
      
      this.rectGraphics[i] = g
      this.container.addChild(this.rectGraphics[i])
    }
    
    // Line
    let lines = dc.drawLine(this.container)
    console.log(lines)

    this.draw()
  },
  methods: {
    setNum(num) {
      this.inputText += num
    },
    clear() {
      this.inputText = ""
    },
    draw() {
      for(let i = 0; i < this.rectGraphics.length; i++) {
        this.rectGraphics[i].alpha = 0
      }

      for(let i = 0; i < this.inputText.length; i++) {
        this.rectGraphics[i].tint = this.palette[this.inputText[i]]
        this.rectGraphics[i].alpha = 1
      }
    },

    closeError() {
      this.isInputError = false
    },

    shareTw() {
      window.open("https://twitter.com/intent/tweet?text=" + encodeURIComponent("バイナリーコードの謎？特設サイトでコードを打ち込め!\n") + this.inputText + encodeURIComponent("\n#01の謎を解け #DrSTONE24巻 #ドクターストーン https://promo.shonenjump.com/drstone/binarymission/"), '_blank');
    },

    toTop() {
      this.$emit("transition", "Top")
    }
  },
  computed: {
    canvas() {
        return this.$refs.canvas;
    },
    ctx() {
        return this.canvas.getContext('2d');
    },
  },
  watch: {
    inputText() {

      this.inputText = this.inputText.replace(/\r?\n/g,"")
      this.inputText = this.inputText.replace(/[^0-9a-fA-F]/gi, '')
      this.inputText = this.inputText.toUpperCase()

      while(this.digit.x * this.digit.y < this.inputText.length) {
        this.inputText = this.inputText.slice(0, -1)
      }

      this.$refs.textarea.scrollTo(0, this.$refs.textarea.scrollHeight)


      if(!this.is16mode && (/[2-9a-fA-F]/gi).test(this.inputText)) {
        this.is16mode = true
        this.is16anime = true
        setTimeout(() => {
          this.is16anime = false
        }, 3000);
      }

      if(this.isDebug) {
        this.draw()
      }
    }
  }
}

</script>

<style lang="scss">

.free {
  background-position-x: center;
  background-position-y: top;
  background-repeat: no-repeat;
  background-size: cover;
  height: auto;
  position: relative;
  width: 100%;

  &__text {
    margin: 0 auto get_percent(10px);
    position: relative;
    width: get_percent(calc_retina3(854px));
    z-index: 10;
  }

  &__input {
    position: relative;
    z-index: 10;
  }

  &__canvas-wrap {
    background: #000;
    height: get_percent(calc_retina3(801px));
    margin: 0 auto 20px;
    position: relative;
    width: get_percent(calc_retina3(801px));
  }

  &__canvas {
    height: 100%;
    position: relative;
    vertical-align: bottom;
    width: 100%;
    z-index: 10;
  }

  &__textfield {
    background: url(../assets/images/textfield.png) top left no-repeat;
    background-attachment: local;
    background-size: cover;
    height: get_vw(calc_retina3(225));
    margin: 0 auto get_percent(calc_retina3(45px));
    padding-top: get_percent(18px);
    width: get_percent(calc_retina3(801px));

    @include mq_pc {
      height: 75px;
    }
  }

  &__textarea {
    background: rgba(0, 0, 0, 0);
    color: #FFF;
    display: block;
    font-size: 1.0rem;
    @include fontVw(10);
    height: get_vw(56);
    margin: 0 auto get_percent(calc_retina3(45px), calc_retina3(801px));
    letter-spacing: 0.8vw;
    line-height: 1.8;
    overflow-wrap: break-word;
    padding: 0 get_percent(11px, calc_retina3(801px));
    resize: none;
    width: 100%;

    @include mq_pc {
      font-size: 1.0rem;
      height: 56px;
      letter-spacing: 0.4rem;
    }
  }

  &__btns {
    display: flex;
    justify-content: space-between;
    margin: 0 auto get_percent(calc_retina3(48px));
    width: get_percent(calc_retina3(1000px));
  }

  &__btn {
    &--0 {
      width: get_percent(calc_retina3(330px), calc_retina3(1000px));
    }
    &--1 {
      width: get_percent(calc_retina3(340px), calc_retina3(1000px));
    }
    &--clear {
      width: get_percent(calc_retina3(270px), calc_retina3(1000px));
    }
  }

  &__tw {
    display: block;
    margin: 0 auto get_percent(calc_retina3(48px));
    width: get_percent(calc_retina3(801px));
  }

  &__hidden-comment {
    margin-top: get_percent(200px);
    position: absolute;
    right: 0;
    top: 0;
    width: get_percent(calc_retina3(1059px));
    z-index: 100;
  }

  .fadein-enter-active {
    transform: translateY(-20px);
    transition: all .4s ease-in-out;
    opacity: 0;
  }
  .fadein-leave-active {
    transition: all .3s ease-in-out;
    opacity: 0;
  }
  .fadein-enter-to {
    transform: translateY(0px);
    opacity: 1;
  }

  .anime {
    align-items: center;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 200;

    &__inner {
      color: #FFF;
      font-size: 3.0rem;
    }
  }


  .error {
    align-items: center;
    background: rgba(0, 0, 0, 0.368);
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 300;

    &__text {
      color: #F00;
      font-size: 3.0rem;
    }
  }
}

</style>
